<template>
  <div class="carousel-container">
    <Carousel :items-to-show-mobile="2.3" :items-to-show="3.92" :no-arrows="noArrows" :infinity="infinity"
              :items="products">
      <template #default="{item, index}">
        <div class="product-preview">
          <ProductPreview :unit="item.unit"
                          :slug="item.url"
                          :labels="item.labels"
                          :noDiscount="true"
                          :second-image="item.images.second_image"
                          :discount="item.prices.discount"
                          :another-products="item.anotherColors"
                          :price="item.prices.standard"
                          :name="item.bold_name" :main-image="item.images.image"
                          @click="trackClick(item, index)"
                          @another-color-click="trackAnotherColorClick"/>
        </div>
      </template>
    </Carousel>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import ProductPreview from "~/components/molecules/ProductPreview.vue";
import Carousel from "~/components/molecules/Carousel.vue";
import {PRODUCT_VIEW_BLOCKS, saveProductViewContext} from '~/utils/productViewContext.js';

export default {
  props: {
    products: {
      type: Array,
      required: true,
    },
    noArrows: {
      type: Boolean,
      default: false,
    },
    infinity: {
      type: Boolean,
      default: true
    },
    block: {
      type: String,
      default: PRODUCT_VIEW_BLOCKS.recommendedProducts
    }
  },
  components: {
    Carousel,
    ProductPreview,
  },
  methods: {
    trackClick(item, index) {
      saveProductViewContext({
        productId: item.id ?? item.product_id,
        position: index + 1,
        block: this.block,
      })
    },
    trackAnotherColorClick({product, index}) {
      if (!product?.id) {
        return
      }

      saveProductViewContext({
        productId: product.id,
        position: index + 1,
        block: this.block,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.product-preview {
  max-width: 452px;
  margin-right: 24px;

  @include tablets {
    max-width: 352px;
    margin-right: 8px;
  }

  @include mobile {
    max-width: 252px;
    margin-right: 8px;
  }

  &:deep(.mobile-padding) {
    padding: 0 !important;
  }
}
</style>
